import Button from "@Components/Button";

import styles from "../../PropertyDetailsModal.module.scss";
import { IButton } from "@Components/Button/constants";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import { useHistory } from "hooks/useHistory";

type DetailsFooterProps = {
  hideModal: (e?: any) => void;
  actionButtonText?: string;
  actionButtonVariant?: IButton["variant"];
  showResetButton?: boolean;
  resetButtonClick?: () => void;
  actionButtonClick?: () => void;
  disableReset?: boolean;
  disableActionButton?: boolean;
  actionButtonStyle?: any;
  isListingPage?: boolean;
};

const DetailsFooter = ({
  hideModal,
  actionButtonVariant = "primary",
  actionButtonText,
  showResetButton = false,
  resetButtonClick,
  actionButtonClick,
  disableReset = false,
  disableActionButton = false,
  actionButtonStyle = {},
  isListingPage = false,
}: DetailsFooterProps) => {
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();
  actionButtonText = actionButtonText || t("propertypage.components.propertydetailsmodal.gotit");
  const history = useHistory();
  const onCLickHandler = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    if (isListingPage) history.goBack();
    if (hideModal) hideModal(e as any);
  };
  return (
    <div
      className={formatClassNames(
        styles.actionButtonContainer,
        showResetButton && styles.flexContainer,
      )}
    >
      {showResetButton && (
        <Button
          variant="subtle"
          size="md"
          disable={disableReset}
          onClick={() => {
            if (resetButtonClick) resetButtonClick();
            else hideModal();
          }}
          className={`${styles.btn} ${styles.addReviewSubmitBtn}`}
        >
          {t("propertypage.components.propertydetailsmodal.reset")}
        </Button>
      )}
      <Button
        variant={isWhitelabel ? "whiteLabel_primary" : actionButtonVariant}
        size="md"
        onClick={() => {
          if (actionButtonClick) {
            actionButtonClick();
          } else {
            onCLickHandler();
          }
        }}
        disable={disableActionButton}
        className={styles.btn}
        style={actionButtonStyle || {}}
        dataTestId={`property-modal-button-${actionButtonText}`}
      >
        {t(actionButtonText || "")}
      </Button>
    </div>
  );
};

export default wrapperHOC(DetailsFooter, {
  componentName: "DetailsFooter-PropertyDetailsModal-PropertyPage",
  showForChina: true,
});
